import React from 'react';
import { IconProps } from '.';

const SvgArrowDirectionDown = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M12.75 3v15.197l5.721-5.688 1.058 1.064L12 21.058l-7.529-7.485 1.058-1.064 5.721 5.688V3h1.5Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgArrowDirectionDown;
